import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

const singleLineShimmer = [
  { type: ShimmerElementType.line, width: 200, height: 50 },
];

export const SingleLineShimmer = () => (
  <div>
    <Shimmer shimmerElements={singleLineShimmer} />
  </div>
);
